import { render, staticRenderFns } from "./EduTreeSelect.vue?vue&type=template&id=06ff6242&scoped=true"
import script from "./EduTreeSelect.vue?vue&type=script&lang=js"
export * from "./EduTreeSelect.vue?vue&type=script&lang=js"
import style0 from "./EduTreeSelect.vue?vue&type=style&index=0&id=06ff6242&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff6242",
  null
  
)

export default component.exports